module.exports = __webpack_public_path__ + "static/media/peepoComfy.e08014ac.gif";